import { setLoading, setIdle, setSaving } from "../store/common/appStateSlice";
import {
  fetchFeaturedTemplates,
  fetchTemplateCategories,
  getNotification,
  getProjectDetails,
  saveProjectTemplate,
  updateProjectTemplate,
  updateVideoTemplate,
  videoTemplates,
} from "../api/templates";
import {
  setCollection,
  setFeaturedTemplates,
  setTemplateTotalCount,
  setUserTemplates,
  setUserTemplateTotalCount,
  setTemplateLoading,
  setUserTemplateLoading,
  setVideoTemplate,
  setUserVideoTotalCount,
  setVideoTemplateLoading,
  setNotificationData,
  setHasMoreVideoTemplate,
  setHasMoreUserTemplate,
  setHasMoreTemplate,
  setHasMoreVerticalTemplates,
  setVerticalTemplates,
  setHasMoreHorizontalTemplates,
  setHorizontalTemplates,
  setHasMoreHorizontalVideoTemplates,
  setHorizontalVideoTemplates,
  setHasMoreVerticalVideoTemplates,
  setVerticalVideoTemplates,
  updateUserTitle,
  updateVideoTitle,
} from "../store/templates/templatesSlice";
import {
  setIsDoc,
  setIsLink,
  setIsFacelessVideo,
  setIsOnlyAvatar,
  setProjectCategory,
  setProjectId,
  setProjectLoading,
  setProjectMusic,
  setProjectName,
  setIsNonVoice,
  setIsOnlyAIVoice,
} from "../store/project/projectSlice";

import {
  fetchUserDetails,
  fetchUserTemplateById,
  fetchUserTemplates,
  logout,
  redeemPoint,
} from "../api/user";
import { setUserDetails } from "../store/user/userSlice";
import { saveProjectBody } from "../constants/apiRequestBody";
import { deleteLocalEntry, getFromLocal } from "../utils/localStorage";
import { setFonts } from "../store/common/fontsSlice";
import { fetchFonts } from "../api/fonts";
import { setFontsApiCalled, setUserApiCalled } from "../store/common/uiSlice";
import { setCurrentSlideIndex, setSlides } from "../store/slides/slidesSlice";
import { generateProjectId } from "../constants/general";
import { setCanvasSlide } from "../canvasUtils";
import { INITIAL_SLIDE_STATE } from "../constants/states";
import { PAGINATION_OFFSET, showToast } from "../utils/general";
import { setChatGptData } from "../store/script/scriptSlice";
import { clearCookie } from "../utils";
import {
  setHeight,
  setLayout,
  setRatio,
  setWidth,
} from "../store/editor/canvasSlice";
import { TEMPLATE_LAYOUT } from "../constants/dashboard";

export const loadTemplateCategories = () => async (dispatch) => {
  try {
    dispatch(setLoading());

    const data = await fetchTemplateCategories();
    dispatch(setCollection(data));
    dispatch(setIdle());
  } catch (error) {
    console.error("Error loading template categories:", error);
    dispatch(setIdle());
  }
};

export const loadFeaturedTemplates =
  (page, search, offset) => async (dispatch, getState) => {
    try {
      const { templates } = getState().templates;
      const existingTemplates = [...(templates || [])];
      dispatch(setTemplateLoading(true));
      const data = await fetchFeaturedTemplates(page, search, offset);
      const hasMore = (page || 0) * PAGINATION_OFFSET < data.recordsTotal;
      dispatch(setHasMoreTemplate(hasMore));
      const result = [...(data.data || [])];

      dispatch(
        setFeaturedTemplates(
          page === 0 ? [...result] : [...existingTemplates, ...result]
        )
      );

      dispatch(setTemplateTotalCount(data.recordsTotal));
      dispatch(setTemplateLoading(false));
    } catch (error) {
      dispatch(setFeaturedTemplates([]));
      console.error("Error loading featured templates:", error);
      dispatch(setTemplateLoading(false));
    }
  };

export const loadVideoTemplates =
  (page, search, offset) => async (dispatch, getState) => {
    try {
      const { videoTemplate } = getState().templates;
      const existingTemplates = [...(videoTemplate || [])];
      dispatch(setVideoTemplateLoading(true));
      const id = getFromLocal("userId");
      const data = await videoTemplates(id, page);
      const responseVideos = [...(data?.data || [])];
      const hasMore =
        // responseVideos.length !== data.recordsTotal &&
        ((page || 0) + 1) * PAGINATION_OFFSET < data.recordsTotal;
      dispatch(setHasMoreVideoTemplate(hasMore));
      const response =
        page === 0 ? responseVideos : [...existingTemplates, ...responseVideos];
      console.log("videoTemplates", videoTemplates);
      dispatch(setVideoTemplate(response));

      dispatch(setUserVideoTotalCount(data.recordsTotal));
      dispatch(setVideoTemplateLoading(false));
    } catch (error) {
      dispatch(setVideoTemplate([]));
      console.error("Error loading featured templates:", error);
      dispatch(setVideoTemplateLoading(false));
    }
  };

export const loadHorizontalVideoTemplates =
  (page, offset) => async (dispatch, getState) => {
    try {
      const { horizontalVideoTemplates } = getState().templates;
      const existingVideoTemplates = [...(horizontalVideoTemplates || [])];
      dispatch(setVideoTemplateLoading(true));
      const userId = getFromLocal("userId");
      const data = await videoTemplates(
        userId,
        page,
        TEMPLATE_LAYOUT.HORIZONTAL,
        offset
      );
      const responseVideos = [...(data?.data || [])];
      const hasMore =
        // responseVideos.length !== data.recordsTotal &&
        ((page || 0) + 1) * PAGINATION_OFFSET < data.recordsTotal;
      dispatch(setHasMoreHorizontalVideoTemplates(hasMore));
      const templates =
        page === 0
          ? responseVideos
          : [...existingVideoTemplates, ...responseVideos];
      dispatch(setHorizontalVideoTemplates(templates));
      dispatch(setVideoTemplateLoading(false));
    } catch (error) {
      dispatch(setHorizontalVideoTemplates([]));
      console.error("Error loading user templates:", error);
      dispatch(setVideoTemplateLoading(false));
    }
  };
export const loadVerticalVideoTemplates =
  (page, offset) => async (dispatch, getState) => {
    try {
      const { verticalVideoTemplates } = getState().templates;
      const existingVideoTemplates = [...(verticalVideoTemplates || [])];
      dispatch(setVideoTemplateLoading(true));
      const userId = getFromLocal("userId");
      const data = await videoTemplates(
        userId,
        page,
        TEMPLATE_LAYOUT.VERTICAL,
        offset
      );
      const responseVideos = [...(data?.data || [])];
      const hasMore =
        // responseVideos.length !== data.recordsTotal &&
        ((page || 0) + 1) * PAGINATION_OFFSET < data.recordsTotal;
      console.log(hasMore, "hasMore*****************");
      dispatch(setHasMoreVerticalVideoTemplates(hasMore));
      const templates =
        page === 0
          ? responseVideos
          : [...existingVideoTemplates, ...responseVideos];
      dispatch(setVerticalVideoTemplates(templates));
      dispatch(setVideoTemplateLoading(false));
    } catch (error) {
      dispatch(setVerticalVideoTemplates([]));
      console.error("Error loading user templates:", error);
      dispatch(setVideoTemplateLoading(false));
    }
  };

export const loadVerticalTemplates =
  (page, offset) => async (dispatch, getState) => {
    try {
      const { verticalTemplates } = getState().templates;
      const existingTemplates = [...(verticalTemplates || [])];
      dispatch(setUserTemplateLoading(true));
      const userId = getFromLocal("userId");
      const data = await fetchUserTemplates(
        userId,
        page,
        TEMPLATE_LAYOUT.VERTICAL,
        offset
      );
      const responseTemplates = [...(data?.data || [])];
      const hasMore =
        // responseTemplates.length !== data.recordsTotal &&
        ((page || 0) + 1) * PAGINATION_OFFSET < data.recordsTotal;
      dispatch(setHasMoreVerticalTemplates(hasMore));
      const templates =
        page === 0
          ? responseTemplates
          : [...existingTemplates, ...responseTemplates];
      dispatch(setVerticalTemplates(templates));
      dispatch(setUserTemplateLoading(false));
    } catch (error) {
      dispatch(setVerticalTemplates([]));
      console.error("Error loading user templates:", error);
      dispatch(setUserTemplateLoading(false));
    }
  };
export const loadHorizontalTemplates =
  (page, offset) => async (dispatch, getState) => {
    try {
      const { horizontalTemplates } = getState().templates;
      const existingTemplates = [...(horizontalTemplates || [])];
      dispatch(setUserTemplateLoading(true));
      const userId = getFromLocal("userId");
      const data = await fetchUserTemplates(
        userId,
        page,
        TEMPLATE_LAYOUT.HORIZONTAL,
        offset
      );
      const responseTemplates = [...(data?.data || [])];
      const hasMore =
        // responseTemplates.length !== data.recordsTotal &&
        ((page || 0) + 1) * PAGINATION_OFFSET < data.recordsTotal;
      dispatch(setHasMoreHorizontalTemplates(hasMore));
      const templates =
        page === 0
          ? responseTemplates
          : [...existingTemplates, ...responseTemplates];
      dispatch(setHorizontalTemplates(templates));
      dispatch(setUserTemplateLoading(false));
    } catch (error) {
      dispatch(setHorizontalTemplates([]));
      console.error("Error loading user templates:", error);
      dispatch(setUserTemplateLoading(false));
    }
  };

export const loadUserTemplates =
  (page, search = "", offset) =>
  async (dispatch, getState) => {
    try {
      const { userTemplates } = getState().templates;
      const existingTemplates = [...(userTemplates || [])];
      dispatch(setUserTemplateLoading(true));
      const userId = getFromLocal("userId");
      const data = await fetchUserTemplates(userId, page, search, offset);
      const hasMore = (page || 0) * PAGINATION_OFFSET < data.recordsTotal;
      dispatch(setHasMoreUserTemplate(hasMore));
      const templates =
        page === 0
          ? [...(data?.data || [])]
          : [...existingTemplates, ...(data?.data || [])];
      dispatch(setUserTemplates(templates));
      dispatch(setUserTemplateTotalCount(data.recordsTotal));
      dispatch(setUserTemplateLoading(false));
    } catch (error) {
      dispatch(setUserTemplates([]));
      console.error("Error loading user templates:", error);
      dispatch(setUserTemplateLoading(false));
    }
  };

export const loadUserDetails = (callback) => async (dispatch) => {
  const userDetails = await fetchUserDetails();
  if (callback) {
    callback(userDetails);
  }

  dispatch(
    setUserDetails({
      details: userDetails,
      loggedIn: userDetails.authenticated !== false,
      auth: true,
    })
  );
  dispatch(setUserApiCalled(true));
};

export const userLogout = (callback) => async (dispatch) => {
  deleteLocalEntry("userId");
 deleteLocalEntry("Id");
 deleteLocalEntry("trial");
 deleteLocalEntry("auth");
  dispatch(
    setUserDetails({
      details: {},
      loggedIn: false,
      auth: false,
    })
  );
  clearCookie();
  await logout();
  

  callback();
  window.location.href = "https://vidboard.ai";
};

export const loadFonts = () => async (dispatch) => {
  const fonts = await fetchFonts();
  dispatch(setFonts(fonts));
  dispatch(setFontsApiCalled(true));
};

export const loadCanvasDetails = (type, id) => async (dispatch) => {
  dispatch(setLoading());
  dispatch(setIdle());
};

export const setProject = (id, data, canvas) => async (dispatch) => {
  dispatch(setProjectLoading(true));
  // Assuming that data contains jsonData as well as slideSnapshots
  const {
    jsonData,
    slideSnapshots,
    name,
    bgMusic,
    category,
    isFaceless,
    isDoc,
    isLinkVideo,
    // isNonVoice,
  } = data;

  // console.log("set project in  non voice", isNonVoice);
  // Parse the jsonData if it's a JSON string (assuming it's a JSON string)
  const parsedData = JSON.parse(jsonData);
  // Add each slide's thumbnail from slideSnapshots to the corresponding slide in parsedData
  parsedData.forEach((slide, index) => {
    slide.thumbnail = slideSnapshots[index];
  });

  // first slide will be shown first.
  await setCanvasSlide(
    { canvasData: parsedData[0].objects || [] },
    canvas,
    dispatch
  );

  dispatch(setProjectId(id));
  dispatch(setProjectName(name));
  dispatch(setProjectMusic(bgMusic));
  dispatch(setIsFacelessVideo(!!isFaceless));
  // dispatch(setIsNonVoice(!!isNonVoice));
  dispatch(setIsDoc(!!isDoc));
  dispatch(setIsLink(!!isLinkVideo));

  dispatch(
    setSlides(
      parsedData.map((data) => ({
        ...data,
        generatedVoice: data?.voiceFile,
      }))
    )
  );
  dispatch(setProjectCategory(category));
  dispatch(setIdle());
  dispatch(setCurrentSlideIndex(0));
  dispatch(setChatGptData(null));
  dispatch(setProjectLoading(false));
};

export const loadTemplateDetails =
  (id, canvas, navigate, cb) => async (dispatch) => {
    dispatch(setLoading());
    try {
      const data = await getProjectDetails(id);
      dispatch(setProject(id, data, canvas));
      dispatch(setIdle());
      if (cb) {
        cb();
      }
    } catch (error) {
      if (cb) {
        cb();
      }
      navigate("/");
    }
  };
export const loadUserTemplateDetails =
  (id, canvas, navigate, cb) => async (dispatch) => {
    try {
      dispatch(setLoading());

      const data = await fetchUserTemplateById(id);
      dispatch(setProject(id, data, canvas));
      dispatch(setIdle());
      if (cb) {
        cb();
      }
    } catch (error) {
      navigate("/");
    }
  };

export const generateNewIdAndNavigate =
  (
    navigate,
    url,
    name1,
    isAdmin,
    featureTemplateId,
    canvas,
    currentTemplateId,
    width,
    height,
    layout
  ) =>
  async (dispatch, getState) => {
    const { templates, userTemplates } = getState().templates;
    const {
      category,
      isFaceless,
      isOnlyAvatar,
      isDoc,
      isLinkVideo,
      isNonVoice,
      isOnlyAIVoice,
    } = getState().project;

    let data = null;
    const defaultSlides = [
      { ...INITIAL_SLIDE_STATE, label: "1", isFaceless, isNonVoice },
    ];
    dispatch(setLoading());

    if (featureTemplateId) {
      data = await getProjectDetails(featureTemplateId);
      if (canvas) {
        return dispatch(setProject(currentTemplateId, data, canvas));
      }
    } else {
      const slideSnapshots = defaultSlides.map(({ thumbnail }) => thumbnail);
      const slidesWithoutThumbnail = defaultSlides.map(
        ({ thumbnail, ...rest }) => rest
      );
      data = {
        jsonData: JSON.stringify(slidesWithoutThumbnail),
        slideSnapshots,
      };
    }
    if (!data) {
      showToast("Something went wrong.!");
      return;
    }
    const projectId = generateProjectId();
    const user = getFromLocal("userId");
    const date = new Date();
    const name = [
      date.getDate(),
      date.getMonth(),
      date.getFullYear(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
    ].join("");
    const projectRequestBody = saveProjectBody({
      ...data,
      category: isAdmin ? category : null,
      templateId: projectId,
      name: `Theme-` + name,
      user,
      isFaceless,
      isDoc,
      isLinkVideo,

      layoutDimension: `w=${width}xh=${height}`,
      layout: layout,
      isNonVoice,
    });

    const response = await saveProjectTemplate(
      user,
      projectRequestBody,
      isAdmin
    );

    if (!isAdmin) {
      dispatch(setUserTemplates([response, ...userTemplates]));
    } else {
      dispatch(setFeaturedTemplates([response, ...templates]));
    }
    dispatch(setIsFacelessVideo(!!isFaceless));
    dispatch(setIsLink(!!isLinkVideo));
    dispatch(setIsDoc(!!isDoc));
    dispatch(setIsOnlyAvatar(!!isOnlyAvatar));
    dispatch(setIsNonVoice(!!isNonVoice));
    // dispatch(setIsOnlyAIVoice(!!isOnlyAIVoice));
    dispatch(setProjectId(""));
    dispatch(setProjectName(name));
    dispatch(setIdle());
    dispatch(setHeight(height));
    dispatch(setWidth(width));
    dispatch(setLayout(layout));

    const queryParams = new URLSearchParams();
    queryParams.append("width", width);
    queryParams.append("height", height);
    queryParams.append("layout", layout);

    // Append query parameters to URL
    const finalUrl = url + projectId + "?" + queryParams.toString();

    navigate(name1 === "My new template" ? finalUrl : url + projectId);
  };

export const saveProject =
  (id, shouldShowToast, callback) => async (dispatch, getState) => {
    try {
      if (shouldShowToast) {
        dispatch(setSaving());
      }
      const slides = getState().slides.slides;
      const { width, height, layout } = getState().canvas;

      const { userTemplates, templates } = getState().templates;

      const { name, category, bgMusic, type, isFaceless, isNonVoice } =
        getState().project;
      const isUserTemplate = type === "user-template";

      const slidesWithoutThumbnail = slides.map(
        ({ thumbnail, ...rest }) => rest
      );

      // Create the "slide_snapshots" array from the removed "thumbnail" values
      const slideSnapshots = slides.map(({ thumbnail }) => thumbnail);

      const user = getFromLocal("userId");
      const projectRequestBody = saveProjectBody({
        templateId: id,
        name,
        jsonData: JSON.stringify(slidesWithoutThumbnail),
        slideSnapshots,
        layoutDimension: `w=${width}xh=${height}`,
        layout: layout,
        category: isUserTemplate ? null : category,
        bgMusic,
        user,
        isFaceless,
        // isNonVoice,
      });

      const resp = await updateProjectTemplate(
        user,
        projectRequestBody,
        !isUserTemplate
      );
      const existingTemplates = [
        ...(isUserTemplate ? userTemplates : templates),
      ];
      const findIndex = existingTemplates.findIndex((t) => t.id === id);
      if (findIndex !== -1) {
        existingTemplates.splice(findIndex, 1, resp.data);
      }
      if (isUserTemplate) {
        dispatch(setUserTemplates(existingTemplates));
      } else {
        dispatch(setFeaturedTemplates(existingTemplates));
      }
      dispatch(setIdle());
      if (shouldShowToast) {
        showToast("Template saved successfully.");
      }
      if (callback) {
        callback();
      }
    } catch (err) {
      dispatch(setIdle());
      console.log(err, "error while saving templates");
      showToast("Something went wrong.!", "", "danger");
    }
  };

export const upDateTemplateTitle = (id, user, name) => async (dispatch) => {
  try {
    dispatch(setLoading());
    await updateProjectTemplate(user, { template_id: id, name }, false);
    dispatch(setIdle());
    dispatch(updateUserTitle({ id, name }));
  } catch (err) {
    dispatch(setIdle());
  }
};
export const updateVideoTemplateTitle =
  (id, user, name) => async (dispatch) => {
    try {
      const userId = getFromLocal("userId");

      dispatch(setLoading());
      await updateVideoTemplate(user || userId, id, { name });
      dispatch(updateVideoTitle({ id, name }));
      dispatch(setIdle());
    } catch (err) {
      dispatch(setIdle());
    }
  };

export const downloadVideo = (id) => async (dispatch, getState) => {
  console.log("download", id);
  try {
    const { activeLayout, horizontalVideoTemplates, verticalVideoTemplates } =
      getState().templates;
    const videoTemplate =
      activeLayout === TEMPLATE_LAYOUT.VERTICAL
        ? verticalVideoTemplates
        : horizontalVideoTemplates;
    const image = videoTemplate.find((item) => item.id === id)?.filePath;
    console.log("image", image);
    const newImage =
      image.includes("vidboard.ai") || image.includes("vidboard-ai")
        ? image
        : process.env.REACT_APP_SERVER_API_URL + image;

    const response = await fetch(newImage);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = newImage.includes("webm") ? "video.webm" : "video.mp4";
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch (error) {
    console.error("Error fetching or downloading video:", error);
    // Dispatch an action if needed, e.g., to update state with error information
  }
};

export const redeemPointFun = (args) => async (dispatch) => {
  try {
    console.log("args", args);
    const data = await redeemPoint(args);
    console.log("redeemPointData", data);
  } catch (error) {
    // console.log("error", error.response.data.message);
    showToast(error.response.data.message, "", "danger");
  }
};

export const getNotificationFun = () => async (dispatch) => {
  try {
    const data = await getNotification();
    console.log("data -", data);
    dispatch(setNotificationData(data?.data));
  } catch (error) {
    // console.log("error", error.response.data.message);
    showToast(error.response.data.message, "", "danger");
  }
};
